import thunk from 'redux-thunk';
import AnalyticsMiddleware from './AnalyticsMiddleware';
import APIMiddleware from './APIMiddleware';
import ErrorMiddleware from './ErrorMiddleware';
import LoginMiddleware from './LoginMiddleware';
import ModalMiddleware from './ModalMiddleware';
import MetaMiddleware from './MetaMiddleware';
import OTPMiddleware from './OTPMiddleware';
import SessionMiddleware from './SessionMiddleware';
export default [
  thunk,
  MetaMiddleware,
  AnalyticsMiddleware,
  APIMiddleware,
  ErrorMiddleware,
  SessionMiddleware,
  OTPMiddleware,
  ModalMiddleware,
  LoginMiddleware,
];
